export const SEARCH_TERMS_CAPABILITY = 'merchandising_search_terms_v1';
export const ADVANCED_CONDITIONS_CAPABILITY = 'merchandising_advanced_conditions_v1';

export const NUMERIC_COMPARISON_OPERATORS = new Set([
  'gt', 'gte', 'lt', 'lte', 'between',
]);

export const REGEX_OPERATORS = new Set([
  'matches_regex', 'not_matches_regex',
]);

export const TEXT_COMPARISON_OPERATORS = new Set([
  'text_contains_any', 'text_not_contains_any', 'text_contains_any_case',
]);

const NATIVE_NUMBER_FIELDS = new Set(['price', 'stock_quantity']);

const descriptorForField = (conditionFields, field) => {
  if (Array.isArray(conditionFields)) {
    return conditionFields.find(descriptor => descriptor?.key === field) || null;
  }
  return conditionFields?.[field] || null;
};

const operatorRequiresAdvancedCapability = (operator, descriptor, field) => {
  if (TEXT_COMPARISON_OPERATORS.has(operator) || REGEX_OPERATORS.has(operator)) return true;
  if (!NUMERIC_COMPARISON_OPERATORS.has(operator)) return false;
  if (descriptor) return descriptor.value_type !== 'number';

  // Price and stock quantity are numeric in the v1 plugin contract. Unknown
  // fields fail closed because old plugin runtimes treat attributes as lists.
  return !NATIVE_NUMBER_FIELDS.has(field);
};

export const conditionOperatorRequiresAdvancedCapability = (
  condition,
  conditionFields = {},
) => {
  const descriptor = descriptorForField(conditionFields, condition?.field);
  return operatorRequiresAdvancedCapability(condition?.operator, descriptor, condition?.field);
};

export const conditionOperatorAvailable = (
  operator,
  descriptor,
  advancedConditions,
) => advancedConditions || !operatorRequiresAdvancedCapability(
  operator,
  descriptor,
  descriptor?.key,
);

const conditionsUseAdvancedOperators = (group, conditionFields) => (
  (group?.items || []).some(item => (
    Array.isArray(item?.items)
      ? conditionsUseAdvancedOperators(item, conditionFields)
      : conditionOperatorRequiresAdvancedCapability(item, conditionFields)
  ))
);

export const ruleUsesAdvancedConditions = (rule, conditionFields = {}) => (
  conditionsUseAdvancedOperators(rule?.conditions, conditionFields)
);

export const ruleUsesSearchTermActions = rule => (rule?.actions || [])
  .some(action => action?.type === 'search_terms.add');
